import React from 'react'

import { Order, OrderSection } from '../redux/types'
import { maskMoney } from 'util/masks'

const OrderProducts: React.FC<{ order: Order }> = ({ order }) => {
  return (
    <div className="row">
      {
        order.products.map((item) => {
          const sections = item.sections.reduce((acc: OrderSection[], section) => {
            let sectionIndex = acc.findIndex(obj => obj.id === section.id)
            if (sectionIndex === -1) {
              acc.push({ id: section.id, name: section.name, order: section.order, items: [] })
              sectionIndex = acc.length - 1
            }

            if (acc[sectionIndex]) {
              section.items.map(item => {
                acc[sectionIndex].items.push(item)
              })
            }

            return acc
          }, [])

          return (
            <div className="row" key={Math.random()}>
              <div className="row panel">

                <img
                  className="border-radius"
                  src={item.picture}
                  style={{ height: 50, width: 50 }}
                />

                <div className="grow padding-left-8">
                  <p className="bold">{ item.name }</p>
                  <h3>
                    { item.quantity }x { maskMoney(item.price) } = { maskMoney(item.total) }
                  </h3>
                </div>

                {
                  sections
                    .sort((a, b) => a.order - b.order)
                    .map(section => {
                      return (
                        <div
                          className="row"
                          style={{ opacity: 0.4 }}
                          key={Math.random()}
                        >
                          <p className="row justify-start">{ section.name }</p>
                          {
                            section.items.map(item => {
                              return (
                                <div key={Math.random()} className="row">
                                  <img
                                    className="border-radius"
                                    src={item.picture}
                                    style={{ height: 50, width: 50 }}
                                  />

                                  <div className="grow padding-left-8">
                                    <p className="bold">{item.name} { item.alias }</p>
                                    <h3>
                                      { item.quantity }x { maskMoney(item.price) } = { maskMoney(item.total) }
                                    </h3>
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                    })
                }
              </div>
              {
                !!item.annotation &&
                <p className="row primary" style={{ marginTop: -12, borderRadius: '0 0 5px 5px' }}>
                  { item.annotation }
                </p>
              }
            </div>
          )
        })
      }
    </div>
  )
}

export default OrderProducts
